export const THIS_GITHUB_URL = "https://github.com/snamiki1212/plangoab";
